(function () {

const initProductAccordion = () => {
    $(".about__accordion-toggle").click(function () {
      const $this = $(this);
      const $description = $this.siblings(".about__accordion-description");

      // If this accordion is already open, close it
      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $description.stop().slideUp(300); // Close the current open accordion
      } else {
        // Otherwise, close all other open accordions first
        $(".about__accordion-toggle").removeClass("active");
        $(".about__accordion-description").slideUp(300);

        // Then open the clicked accordion
        $this.addClass("active");
        $description.stop().slideDown(300); // Open the clicked accordion
      }
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
  });

  initProductAccordion();
  initZoomImage();
})();
